module.exports = __webpack_public_path__ + "static/media/certificate.be59c0c1.svg";